import clsx from 'clsx';
import { ChevronRight } from 'lucide-react';
import Link from 'next/link';
import { MouseEvent, ReactNode } from 'react';

import styles from './RowLinkCell.module.scss';

interface RowLinkCellProps {
  href: string;
  className?: string;
  children: ReactNode;
}

const cancelOnSelection = (e: MouseEvent<HTMLAnchorElement>) => {
  const selection = window.getSelection();
  if (selection && !selection.isCollapsed && selection.containsNode(e.currentTarget, true)) {
    e.preventDefault();
  }
};

export const RowLinkCell = ({ href, className, children }: RowLinkCellProps) => (
  <div className={clsx(styles.cell, className)}>
    <Link
      href={href}
      className={styles.text}
      onClick={cancelOnSelection}
      data-testid="row-link"
    >
      {children}
    </Link>
    <Link
      href={href}
      className={styles.open}
      tabIndex={-1}
      aria-hidden
      data-testid="row-open"
    >
      <ChevronRight size={13} />
      Open
    </Link>
  </div>
);
